export default class SinglePage {
    constructor() {
        this.singlePostPage = document.querySelector('.single-post');
        if (!this.singlePostPage)
            return;
        this.postDate = this.singlePostPage.querySelector('.post-date');
        this.postContent = this.singlePostPage.querySelector('.col-post-content');
        this.calculateReadTime();
    }
    calculateReadTime() {
        if (!this.postContent)
            return;
        const textContent = this.postContent.innerText || '';
        const wordCount = textContent.trim().split(/\s+/).length;
        const wordsPerMinute = 200;
        const readTime = Math.ceil(wordCount / wordsPerMinute);
        this.postDate.querySelector('span').innerHTML = `${readTime}`;
    }
}
